
import HesseFooter from '@/components/layout/Footer'
export default {
  name: 'LandingpageLayout',
  components: { HesseFooter },
}
